import { SET_ALL_LEAVES, SET_LEAVE_PAGE, SET_LEAVE_PAGE_SIZE, SET_LEAVE_TOTAL } from "../types"

export const setAllLeaves = (leaves) => ({
    type: SET_ALL_LEAVES,
    payload: leaves,
})

export const setLeavePage = (page) => ({
    type: SET_LEAVE_PAGE,
    payload: page,
})

export const setLeavePageSize = (size) => ({
    type: SET_LEAVE_PAGE_SIZE,
    payload: size,
})

export const setLeaveTotal = (total) => ({
    type: SET_LEAVE_TOTAL,
    payload: total,
})